module.exports = __webpack_public_path__ + "static/media/indulge.adf341c2.jpeg";